// @flow
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    commentForm: {
      active: true,
      id: -1,
    },
    commentOptions: {
      id: -1,
    },
    commentSort: 'newest',
    comments: [],
    commentsLoading: {
      amount: 0,
      parent: -1,
      status: false,
    },
    commentableId: -1,
    commentableType: '',
    totalComments: 0,
  },

  mutations: mutations,

  actions: actions,

  getters: getters,
}
